// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramSingleFamilyV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AccountViewListingAdvertisingDto, ListingAlias } from '../..';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_Path =
  '/api/web/v2/users/accountView/zram/singleFamily/properties/advertising';

/**
 * Get single family customer account view property listing advertising
 */
export const RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising = (
  getParams: AdvertisingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AdvertisingParams, never, AccountViewListingAdvertisingDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
